import { Form } from 'react-bootstrap';
import React from 'react';
import ReactDatePicker from 'react-datepicker';
import { Controller } from 'react-hook-form';
import { isMatch, parse } from 'date-fns';

export function DatePicker({
  control,
  label,
  name,
  disabled,
  dateFormat,
  readOnly,
  maxDate = null,
  minDate = null,
  errorMessage = null,
  onChangeHandler = () => true
}) {
  const handleDateChangeRaw = (e) => {
    if (!e.target.value || e.target.value.length < 1) {
      e.preventDefault();
      return;
    }
    if (isMatch(e.target.value, dateFormat)) {
      onChangeHandler(name, parse(e.target.value, dateFormat, new Date()));
    }
  };

  return (
    <div className="configuration-col">
      <Form.Group className="custom-form-control">
        <Form.Label>{label}</Form.Label>
        <Controller
          name={name}
          control={control}
          render={({ field }) => {
            const parsed = field.value ? field.value : null;
            const format = (d) => {
              const isValid = onChangeHandler(name, d);
              if (isValid === false) {
                return;
              }
              return field.onChange(d);
            };
            const handleBlur = () => {
              if (parsed) {
                onChangeHandler(name, parsed);
              }
            };
            const handleKeyDown = (e) => {
              if (e.key === 'Enter') {
                handleBlur();
              }
            };
            return (
              <ReactDatePicker
                selected={parsed}
                onChange={format}
                onBlur={handleBlur}
                onKeyDown={handleKeyDown}
                dateFormat={dateFormat}
                className={`form-control${errorMessage ? ' is-invalid' : ''}`}
                popperPlacement="bottom-end"
                showMonthDropdown
                showYearDropdown
                onChangeRaw={handleDateChangeRaw}
                disabled={!!disabled}
                readOnly={!!readOnly}
                maxDate={maxDate}
                minDate={minDate}
              />
            );
          }}
        />
        {errorMessage && <div className="invalid-feedback d-block">{errorMessage}</div>}
      </Form.Group>
    </div>
  );
}
